import styled from 'styled-components';

import Logo23 from './assets/remote-logo-23.svg';
import Logo28 from './assets/remote-logo-28.svg';
import LogoAffiliates28 from './assets/remote-affiliates-logo-28.svg';
import LogoPartners28 from './assets/remote-partners-logo-28.svg';
import LogoConnect28 from './assets/remote-connect-logo-28.svg';

import Mark28 from './assets/remote-mark-28.svg';

export const RemoteBrandLogo23 = styled(Logo23)``;
export const RemoteBrandLogo28 = styled(Logo28)``;
export const RemoteAffiliatesLogo28 = styled(LogoAffiliates28)``;
export const RemotePartnersLogo28 = styled(LogoPartners28)``;
export const RemoteConnectLogo28 = styled(LogoConnect28)``;

export const RemoteBrandMark28 = styled(Mark28)``;
